import { useEffect, useRef } from "react"
import Flickity from "react-flickity-component"

import { Heading } from "@trueskin-web/components"

import azelanicAcidImg from "../images/azelanicAcid.webp"
import niacinamidImg from "../images/niacinamid.webp"
import vitaminAImg from "../images/vitamin.webp"

const SLIDES = [
  {
    title: "Vitamin-A-Säure",
    image: vitaminAImg,
    tags: [
      "Fördert Zellregeneration",
      "Reduziert Falten",
      "Reinigt Poren",
      "Fördert Hautstraffheit",
    ],
  },
  {
    title: "Niacinamid",
    image: niacinamidImg,
    tags: [
      "Verbessert die Hauttextur",
      "Stärkt die Hautbarriere",
      "Reguliert Talgproduktion",
      "Gleicht Hautton aus",
    ],
  },
  {
    title: "Azelainsäure",
    image: azelanicAcidImg,
    tags: [
      "Reduziert Pigmentflecken",
      "Fördert Zellerneuerung",
      "Lindert Rötungen",
      "Verfeinert das Hautbild",
    ],
  },
]

const flickityOptions = {
  cellAlign: "left",
  contain: true,
  wrapAround: true,
  prevNextButtons: false,
  pageDots: false,
}

const IngredientsCarousel = () => {
  const flickityRef = useRef(null)

  //! This "hack" is needed to properly working Flickity with wrapAround option
  useEffect(() => {
    const instance = flickityRef.current
    if (!instance) return
    instance.on("ready", () => {
      const slider = instance.element.querySelector(".flickity-slider")
      if (slider) slider.style.transform = "translateX(0)"
    })
  }, [])

  return (
    <div
      sx={{
        width: ["100vw", "100%"],
        position: "relative",
        left: ["50%", 0],
        mr: [null, "auto"],
        mb: 4,
        pb: 6,
        bg: "#FFF",
        ml: ["-50vw", 0],
        borderRadius: "32px",
        overflow: "hidden",
      }}
    >
      <div sx={{ pt: 6, px: 5 }}>
        <Heading
          as="h3"
          sx={{ fontSize: 5, mb: 4, fontWeight: "bold", lineHeight: 1.333 }}
        >
          Das wirksamste Mittel, das Du kriegen kannst
        </Heading>
        <p sx={{ fontSize: 1, mb: 4, lineHeight: 1.428 }}>
          Mit wissenschaftlich geprüften Wirkstoffen. Dermatologisch entwickelt,
          individuell angepasst und bequem zu Dir nach Hause geliefert.
        </p>
      </div>

      <div sx={{ px: 5, "& *": { outline: "none" } }}>
        <Flickity
          options={flickityOptions}
          flickityRef={(c) => (flickityRef.current = c)}
        >
          {SLIDES.map(({ title, image, tags }) => (
            <div
              key={title}
              sx={{
                width: ["64.5%", "300px"],
                mr: 5,
                minWidth: "260px",
                maxWidth: "80vw",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <img
                src={image}
                alt={title}
                sx={{ width: "100%", mb: 4, borderRadius: "12px" }}
              />
              <Heading
                as="h4"
                sx={{
                  fontSize: 2,
                  mb: 2,
                  lineHeight: 1.428,
                  fontWeight: "bold",
                }}
              >
                {title}
              </Heading>
              <div sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                {tags.map((tag) => (
                  <div
                    key={tag}
                    sx={{
                      borderRadius: "8px",
                      background: "#F6F6F6",
                      backdropFilter: "blur(6px)",
                      p: "4px 8px",
                      fontSize: 0,
                    }}
                  >
                    <p
                      sx={{
                        color: "#767676",
                        m: 0,
                        lineHeight: 1.333,
                        fontSize: 0,
                      }}
                    >
                      {tag}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </Flickity>
      </div>
    </div>
  )
}

export default IngredientsCarousel
